import React from 'react';
import { FooterRow, FooterCol, LogoFooterCol } from './vietnamfooter.styles';
import {
  Container,
  Footerlink,
  SiteFooter,
  TeConsentBlackBar,
  Disclaimer,
} from 'components/Footer/Footer.styles';
import { useContentful, useDoctorProfile } from 'reactQuery/queries';

const FooterVietnam: React.FC = () => {
  const resourcesAppHost = 'https://resources.invisalign.com';
  const { data: doctorProfile } = useDoctorProfile();
  const { data: contentfulData } = useContentful();
  const {
    privacyPolicy,
    termsOfUse,
    termsAndConditions,
    supportText,
    disclaimer,
  } = contentfulData?.globalContents || {};

  let privacyPolicyLink = '';
  let termsOfUseLink = '';
  let termsAndConditionsLink = '';
  let supportTextContent = '';
  let disclaimerContent = '';
  const doctorCountry = doctorProfile?.country ?? 'US';

  if (doctorProfile && typeof doctorProfile.region !== 'undefined') {
    privacyPolicyLink = privacyPolicy[doctorProfile.region];
    termsOfUseLink =
      termsOfUse[doctorProfile.region] ?? termsOfUse[doctorCountry];
    termsAndConditionsLink =
      termsAndConditions[doctorProfile.region] ??
      termsAndConditions[doctorCountry];
    supportTextContent =
      supportText[doctorProfile.country] ?? supportText['GB'];
    disclaimerContent = disclaimer[doctorProfile.country] ?? disclaimer['ENG'];
  }
  return (
    <Container>
      <div className="container" style={{ textAlign: 'center' }}>
        <div className="office-address">
          <h4>
            <b>CÔNG TY TNHH INVISALIGN VIỆT NAM</b>
          </h4>
          <h4>
            <b>INVISALIGN VIETNAM CO., LTD</b>
          </h4>
          <p>
            Giấy chứng nhận đăng ký doanh nghiệp số: 0315613803 do Sở Kế hoạch
            và Đầu tư Thành phố Hồ Chí Minh cấp chứng nhận lần đầu ngày 06 tháng
            4 năm 2019
          </p>
          <p>
            Enterprise Registration Number: 0315613803 issued by the Department
            of Planning and Investment of Ho Chi Minh City on 6 April 2019
          </p>
          <p>
            Địa chỉ trụ sở chính: Tầng 4, Phú Mỹ Hưng Tower, số 101 đường Tôn
            Dật Tiên, Phường Tân Phú, Quận 7, Thành phố Hồ Chí Minh, Việt Nam
          </p>
          <p>
            Head office address: Floor 4, Phu My Hung Tower, 101 Ton Dat Tien
            Street, Tan Phu Ward, District 7, Ho Chi Minh City, Vietnam
          </p>
        </div>
        <br />
        <div className="office-address">
          <p>
            <u>Bộ phận Chăm sóc Khách hàng</u>
          </p>
          <p>
            <u>Customer Support</u>
          </p>
          <p>Hotline: 1800646490</p>
          <p>Giờ làm việc: Thứ 2 đến thứ 6 từ 8h30 – 17h30</p>
          <p>Working hours: Monday to Friday 8h30 – 17h30</p>
          <p>
            Email (sản phẩm liên quan Invisalign/Invisalign-related products):{' '}
            <a href="mailto:CS-VN@aligntech.com">CS-VN@aligntech.com</a>
          </p>
          <p>
            Email (sản phẩm liên quan iTero/ iTero-related products):{' '}
            <a href="mailto:iterosupportVN@aligntech.com">
              iterosupportVN@aligntech.com
            </a>
          </p>
        </div>
      </div>
      <br />
      <div className="container" style={{ textAlign: 'center' }}>
        <div className="demo-files">
          <FooterRow>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/order_guide_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Hướng dẫn đặt hàng
              </Footerlink>
            </FooterCol>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/payment_process_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Quy trình thanh toán
              </Footerlink>
            </FooterCol>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/delivery_policy_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chính sách giao hàng
              </Footerlink>
            </FooterCol>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/return_policy_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chính sách kiểm hàng – đổi trả
              </Footerlink>
            </FooterCol>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/warranty_policy_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chính sách bảo hành
              </Footerlink>
            </FooterCol>
          </FooterRow>
          <br />
          <FooterRow>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/dr_privacy__footnote_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chính sách bảo mật và giải quyết
                <br /> khiếu nại về bảo vệ dữ liệu cá nhân
              </Footerlink>
            </FooterCol>
            <FooterCol>
              <Footerlink
                href={`${resourcesAppHost}/vi-vn/documents/webstore_terms_of_use_vn.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Điều khoản sử dụng
              </Footerlink>
            </FooterCol>
            <LogoFooterCol>
              <a
                href="http://online.gov.vn/Home/WebDetails/114223"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  title=""
                  src="https://images.ctfassets.net/71gql6049r0g/7rL4s2aDGDcrp8O9fk7LHO/1346cec18a117b6413541cb7c78e0ed5/logoSaleNotiVN.png"
                  width="30%"
                  alt="Sale Notification Logo"
                />
              </a>
            </LogoFooterCol>
          </FooterRow>
          <br />
          <FooterRow>
            <FooterCol>
              <SiteFooter>
                <div
                  dangerouslySetInnerHTML={{
                    __html: supportTextContent,
                  }}
                ></div>
                <div>
                  <Footerlink
                    rel="noreferrer"
                    target="_blank"
                    href={termsAndConditionsLink}
                  >
                    Điều khoản và Điều kiện.
                  </Footerlink>
                </div>
              </SiteFooter>
            </FooterCol>
          </FooterRow>
          <FooterRow>
            <FooterCol>
              <SiteFooter>
                <div>© Bản quyền thuộc về Align Technology, Inc.</div>
                <div>
                  <Footerlink
                    rel="noreferrer"
                    target="_blank"
                    href={privacyPolicyLink}
                  >
                    Quyền riêng tư​
                  </Footerlink>
                  <Footerlink
                    rel="noreferrer"
                    target="_blank"
                    href={termsOfUseLink}
                  >
                    Điều khoản sử dụng​
                  </Footerlink>
                </div>
              </SiteFooter>
            </FooterCol>
          </FooterRow>
        </div>
      </div>
      <br />
    </Container>
  );
};

export default FooterVietnam;
